import { JSX } from 'react'

import { IconProps } from '../../icon'

const Done: (props: IconProps) => JSX.Element = ({
  dataTestId,
  height,
  id,
  stroke,
  title,
  width,
}: IconProps) => (
  <svg
    data-testid={dataTestId}
    fill='none'
    height={height || 48}
    id={id}
    stroke={stroke}
    viewBox='0 0 33 32'
    width={width || 48}
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>{title}</title>
    <g clipPath='url(#clip0_671_66)'>
      <path
        d='M32.5141 16L28.8916 11.9781L29.4588 6.59361L24.1616 5.47224L21.4595 0.778259L16.5141 2.98852L15.8466 16L16.5141 29.0115L21.4596 31.2217L24.1616 26.5278L29.4588 25.4064L28.8916 20.0219L32.5141 16Z'
        fill='#0ED678'
      />
      <path
        d='M11.5686 0.778259L8.86661 5.47224L3.56945 6.59367L4.13665 11.9781L0.514099 16L4.13665 20.0219L3.56945 25.4064L8.86661 26.5278L11.5687 31.2217L16.5141 29.0115V2.98852L11.5686 0.778259Z'
        fill='#04EB84'
      />
      <path
        d='M23.2217 12.4966L21.8212 11.2465L16.5141 17.1923L15.8466 18.6699L16.5141 20.0115L23.2217 12.4966Z'
        fill='#F7F0EB'
      />
      <path
        d='M10.9368 14.5862L9.60945 15.9137L15.1903 21.4946L16.5141 20.0115V17.1923L15.1129 18.7622L10.9368 14.5862Z'
        fill='#FFFBF5'
      />
    </g>
    <defs>
      <clipPath id='clip0_671_66'>
        <rect
          width='32'
          height='32'
          fill='white'
          transform='translate(0.514099)'
        />
      </clipPath>
    </defs>
  </svg>
)

export default Done
